import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

export interface HelpRequestContext {
  requestId?: string | null;
  errorCode?: string | null;
}

interface HelpContextValue {
  isOpen: boolean;
  details: HelpRequestContext;
  open: (details?: HelpRequestContext) => void;
  close: () => void;
}

const noop = () => undefined;
const FALLBACK: HelpContextValue = { isOpen: false, details: {}, open: noop, close: noop };

const HelpContext = createContext<HelpContextValue>(FALLBACK);

/** «Помощь» в каждом разделе (ПОРТ-61): открывается кнопкой в верхней панели или из состояния ошибки. */
export function HelpProvider({ children }: { children: ReactNode }) {
  const [isOpen, setOpen] = useState(false);
  const [details, setDetails] = useState<HelpRequestContext>({});
  const open = useCallback((next: HelpRequestContext = {}) => {
    setDetails(next);
    setOpen(true);
  }, []);
  const close = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ isOpen, details, open, close }), [isOpen, details, open, close]);
  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
}

export function useHelp(): HelpContextValue {
  return useContext(HelpContext);
}
